// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';
import { WtrRootState, WtrStore } from './create-store';

export const useWtrDispatch: () => WtrDispatch = useDispatch;
export const useWtrSelector: TypedUseSelectorHook<WtrRootState> = useSelector;
export const useWtrStore: () => WtrStore = useStore;

export { useWtrDispatch as useDispatch, useWtrSelector as useSelector };
